<template>
  <div class="contentBox" :class="device=='mobile'?'mobileBox':''">
    <button class="btn btn-back" @click="goBack"></button>
    <web ref="web"></web>
    <p class="title">{{videoData.title}}</p>
    <p class="msg">母题{{num}}</p>
    <div class="item">
      <div class="left">
        <video id="video"  @contextmenu.prevent :class="[prohibit?'':'',Style]" ref="videoPlayer" :src="'https://pic.bi-rong.com/'+videoUrl" controls @play="VideoPLay" @pause="VideoPause" @ended="VideoEnded"></video>
        <div class="btn btn-videoBtn">
          <button class="btn btn-video-play" @click="videoStart" v-if="video_Status=='pause'"></button>
          <button class="btn btn-video-pause" @click="videoStop" v-if="video_Status == 'play'"></button>
          <button class="btn btn-video-full" @click="videoFull"></button>
          <div class="btn btn-rate">
            <p @click="rateShow">x{{videoRate}}</p>
            <div class="ratelist" v-if="rateType">
              <span :class="videoRate==item.num?'select':''" v-for="(item,index) in rateList" :key="index" @click="rateSub(item)">{{item.title}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="list-item" v-for="(item,index) in videoData.videos" :key="index" @click="videoSub(item,index)">
          <div class="name">
            <div class="txt">第{{(index+1)}}小节<span>{{item.status == 0?'未完成':'已完成'}}</span><button v-if="videoIndex==index" class="btn btn-video" :class="playType?'btn-pause':'btn-play'" @click="videoStatus"></button></div>
            <span>{{item.title}}</span>
            
          </div>
          <div class="status"></div>
        </div>
      </div>
    </div>
    <button class="btn btn-sub" @click="topicSub">去讲解母题</button>
  </div>
</template>
<script>
import { getReadVideoDetail,addReadVideoWatch } from "@/assets/js/api";
import web from './../components/comment/web.vue';
export default {
  name: "login",
  data() {
    return {
      token:'',
      num:'',
      videoData:[],
      videoUrl:'',
      watchObj:{
        rmid:'',
        rpid:'',
        rvid:'',
        watch_time:'',
        total_time:''
      },
      videoType:false,
      device:'',
      prohibit:false,
      Style:'',
      videoTime:'',
      playType:false,
      videoIndex:'',
      video_Status:'pause',
      videoRate:1,
      rateList:[
        {title:'x1.0',num:1},
        {title:'x1.5',num:1.5},
        {title:'x2.0',num:2},
      ],
      rateType:false,
    };
  },
  components: {
    web
  },
  mounted(){
    document.title = '观看视频';
    var userData = JSON.parse(localStorage.getItem('identityData'));
    this.token = userData.apiToken;
    this.num = this.$route.query.num;
    this.watchObj.rmid = this.$route.query.rmid;
    this.watchObj.rpid = this.$route.query.rpid;
    this.getDetail();
    this.device = this.$refs.web.device;
    if(this.device == 'mobile'){
      this.$refs.web.font_resize();
    };
    this.$refs.videoPlayer.controlsList = "nodownload"; 
  },
  methods: {
    async getDetail(){
      var that = this;
      try {
        const response = await getReadVideoDetail({rmid:this.$route.query.rmid,rpid:this.$route.query.rpid},this.token);
        if(response.code == 200){
          that.videoData = response.data;
          response.data.videos.forEach(function(item,index){
            if(item.is_last == 1){
              that.videoUrl = item.video;
              that.watchObj.rvid = item.rvid;
              that.watchObj.total_time = item.total_time;
              that.videoTime = item.watch_time;
              that.videoIndex = index;
            }
          })
          that.$refs.videoPlayer.addEventListener('timeupdate', this.handleTimeUpdate);
          that.$refs.videoPlayer.addEventListener('ended', this.videoEnd);
          if(response.data.is_complete == 1){
            that.videoType = true
          };
          that.$refs.videoPlayer.addEventListener('play', function(e) {
            that.videoData.videos.forEach(function(item,index){
              if(that.videoUrl == item.video){
                if(item.status == 0){
                  that.prohibit = true
                }
              }
            })
            that.playType = true;
          });
          that.getVideo();
          console.log(that.playType)
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    getVideo(){
      var that = this;
      setTimeout(function(){
        var height = that.$refs.videoPlayer.clientHeight;
        var width = that.$refs.videoPlayer.clientWidth;
        if(height > width){
          that.Style = 'height'
        } else {
          that.Style = 'width'
        }
        that.$refs.videoPlayer.currentTime = that.videoTime;
      },500);
    },

    videoSub(e,index){
      var that = this;
      this.videoUrl = e.video;
      this.watchObj.rvid = e.rvid;
      this.watchObj.total_time = e.total_time;
      this.videoIndex = index;
      that.getVideo();
    },

    handleTimeUpdate() {
      var that = this;
      const video = this.$refs.videoPlayer;
      this.currentTime = this.formatTime(video.currentTime); // 格式化时间为 mm:ss 格式
      that.videoData.videos.forEach(function(item,index){
        if(item.rvid == that.watchObj.rvid){
          that.watchObj.watch_time = parseInt(video.currentTime)
          that.videoTime = parseInt(video.currentTime)
        }
      })
    },
    formatTime(seconds) {
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = Math.floor(seconds % 60);
      return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`; // 格式化为 mm:ss 形式
    },
    videoEnd(){
      var that = this;
      var total = 0;
      that.videoData.videos.forEach(function(item,index){
        if(item.rvid == that.watchObj.rvid){
          item.status = 1
        };
        if(item.status == 1){
          total++
        };
        if(total == that.videoData.videos.length){
          that.videoType = true
        }
      })
      that.prohibit = false;
      that.playType = false;
      console.log(total , that.videoData.videos.length,'end')
      this.addReadVideoWatch();
    },

    videoStatus(){
      var that = this;
      console.log(this.playType)
      if(this.playType){
        that.$refs.videoPlayer.pause();
      } else {
        that.$refs.videoPlayer.play();
      }
      this.playType = !this.playType
    },

    async addReadVideoWatch(){
      console.log(this.watchObj)
      var that = this;
      try {
        const response = await addReadVideoWatch(this.watchObj,this.token);
        if(response.code == 200){
          
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    topicSub(){
      var that = this;
      if(this.videoType){
        this.$router.push('/videoTopic?rmid='+this.watchObj.rmid + '&rpid='+this.watchObj.rpid+'&num='+this.num)
      } else {
          that.$message('还没有看完母题视频哦！');
      }
    },

    goBack() {
      var that = this;
      this.addReadVideoWatch();
      that.$router.go(-1);
      setTimeout(function(){
        window.location.reload();
      },100)
    },

    VideoPLay(){
      this.video_Status = 'play'
    },

    VideoPause(){
      this.video_Status = 'pause'
    },
    
    VideoEnded(){
      this.video_Status = 'pause'
    },

    videoStart(){
      this.$refs.videoPlayer.play();
      this.video_Status = 'play'
    },

    videoStop(){
      this.$refs.videoPlayer.pause();
      this.video_Status = 'pause'
    },

    videoFull(){
      const video = this.$refs.videoPlayer;
      if (!document.fullscreenElement) {
        if (video.requestFullscreen) {
          video.requestFullscreen();
        } else if (video.mozRequestFullScreen) { /* Firefox */
          video.mozRequestFullScreen();
        } else if (video.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
          video.webkitRequestFullscreen();
        } else if (video.msRequestFullscreen) { /* IE/Edge */
          video.msRequestFullscreen();
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) { /* Firefox */
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) { /* IE/Edge */
          document.msExitFullscreen();
        }
      }
    },

    rateShow(){
      this.rateType = true;
    },

    rateSub(e){
      this.$refs.videoPlayer.playbackRate = e.num;
      this.videoRate = e.num;
      this.rateType = false;
    }
  },

  
};
</script>
<style scoped>
  .contentBox{
    width: 100%;
    height: 100%;
    padding: 101px 0 75px;
    background-color: #F8F9FC;
  }

  .title{
    color: #333333;
    font-size: 40px;
    display: block;
    font-weight: bold;
    text-align: center;
  }

  .btn-back{
    background-image: url(~@/assets/images/btn-bg1.png);
  }

  .msg{
    font-size: 30px;
    margin: 10px 52px;
    color: #333333;
    display: block;
    text-align: center;
  }

  .item{
    font-size: 0;
    text-align: center;
    height: calc( 100% - 240px );
    overflow-y: auto;
  }

  .item .right,
  .item .left{
    width: 50%;
    display: inline-block;
    vertical-align: top;
    height: 100%;
  }

  .item .left video{
    border: solid 1px #333;
    opacity: 0;
    -webkit-animation: ani_1 1s forwards;
    animation: ani_1 1s forwards;
  }

  .item .left video.width{
    width: 90%;
    height: auto;
  }

  .item .left video.height{
    height: 90%;
    width: auto;
  }

  .item .right{
    text-align: left;
  }

  .list-item{
    font-size: 0;
    text-align: left;
    display: block;
    margin-top: 12px;
  }

  .list-item .name .btn{
    width: 30px;
    height: 30px;
    background-size: 30px 30px;
    margin-left: 30px;
  }

  .list-item .name .btn.btn-pause{
    background-image: url(~@/assets/images/icon13.png);
  }

  .list-item .name .btn.btn-play{
    background-image: url(~@/assets/images/icon12.png);
  }

  .list-item .txt{
    color: #333333;
    font-size: 26px;
    display: block;
  }

  .list-item .txt span{
    font-size: 18px;
    color: #39E72C;
    margin-left: 30px;
  }

  .list-item span{
    font-size: 22px;
    color: #333333;
  }

  .btn-sub{
    font-size: 32px;
    color: #fff;
    padding: 15px 61px;
    border-radius: 60px;
    background-color: #6098F2;
    display: block;
    margin: 10px auto 0;
  }

  .btn-videoBtn{
    display: block;
    margin-top: 20px;
    font-size: 0;
    text-align: left;
    box-sizing: border-box;
    padding: 5px 50px;
  }

  .btn-videoBtn .btn{
    display: inline-block;
    vertical-align: top;
    margin-right: 20px;
  }

  .btn-videoBtn .btn-video-play{
    background-image: url(~@/assets/images/icon15.png);
    width: 40px;
    height: 40px;
    background-size: 40px 40px;
  }

  .btn-videoBtn .btn-video-pause{
    background-image: url(~@/assets/images/icon16.png);
    width: 40px;
    height: 40px;
    background-size: 40px 40px;
  }

  .btn-videoBtn .btn-video-full{
    background-image: url(~@/assets/images/icon17.png);
    width: 40px;
    height: 40px;
    background-size: 40px 40px;
  }

  .btn-videoBtn .btn-rate{
    width: 40px;
    height: 40px;
    background-color: #96BDFD;
    border-radius: 100%;
    display: inline-block;
    vertical-align: top;
    position: relative;
  }

  .btn-videoBtn .btn-rate p{
    color: #fff;
    font-size: 16px;
    line-height: 40px;
    text-align: center;
  }

  .btn-videoBtn .btn-rate .ratelist{
    width: 60px;
    background-color: rgba(0,0,0,.8);
    position: absolute;
    bottom: 50px;
    left: -10px;
    z-index: 10;
  }

  .btn-videoBtn .btn-rate .ratelist span{
    font-size: 16px;
    color: #fff;
    display: block;
    text-align: center;
    line-height: 40px;
    width: 100%;
  }

  .btn-videoBtn .btn-rate .ratelist span.select{
    background-color: #8B8B8B;
    color: #fff;
  }

  .mobileBox .btn-back{
    height: .52rem;
    width: .52rem;
    background-size: .52rem .52rem;
  }

  .mobileBox .title{
    font-size: .3rem;
  }

  .mobileBox .msg{
    font-size: .24rem;
  }

  .mobileBox .list-item p{
    font-size: .22rem;
  }

  .mobileBox .list-item p span{
    font-size: .18rem;
  }

  .mobileBox .list-item span{
    font-size: .16rem;
  }

  @-webkit-keyframes ani_1{
    0%{opacity: 0;transform: scale(.1);}
    50%{opacity: 0;transform: scale(.5);}
    90%{opacity: 0;transform: scale(.7);}
    100%{opacity: 1;transform: scale(1);}
  }
  @keyframes ani_1 {
    0%{opacity: 0;transform: scale(.1);}
    50%{opacity: 0;transform: scale(.5);}
    90%{opacity: 0;transform: scale(.7);}
    100%{opacity: 1;transform: scale(1);}
  }

  @media screen and (max-width: 1600px){
    .contentBox{
      padding: 20px 0 20px;
    }

    .item{
      height: calc( 100% - 240px );
      overflow-y: auto;
      overflow-x: hidden;
    }

    .btn-sub{
      margin: 10px auto 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/identity/videoDetail.vue